module.exports = __webpack_public_path__ + "img/horizontal_6_3_7005.4fc37c49.png";